<template>
  <div class="mod-user">
    <!-- 搜索栏 -->
    <div class="searchBox" :style="{ opacity: config.isConfigMode ? 0.5 : 1, pointerEvents: config.isConfigMode ? 'none' : 'auto' }">
      <el-form :inline="true" :model="dataForm.paramMap" size="small">
        <el-form-item label="模型标识">
          <el-input v-model="dataForm.paramMap.key" placeholder="请输入标识" clearable></el-input>
        </el-form-item>
        <el-form-item label="模型名称">
          <el-input v-model="dataForm.paramMap.name" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="模型类型">
          <el-input v-model="dataForm.paramMap.category" placeholder="请输入类型" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
          <el-button @click="() => this.dataForm.paramMap = {}" type="info">重置</el-button>
          <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
        </el-form-item>
        <el-form-item style="text-align: right; display: flex; justify-content: flex-end; align-items: center;">
          <div class="operationList">
            <el-button size="small" type="success" @click="operation('ADD',undefined)">添加流程设计</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格栏 -->
    <div class="tableBox"  :style="{ position: 'relative' }">
      <!-- 配置模式 -->
      <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
        <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
        <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
        <el-popover placement="right" width="520" trigger="click">
          <div style="justify-self: center;">
            <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
            <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
            <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
              <i class="el-icon-view el-icon--right" />
            </el-tooltip>
          </div>
          <br/>
          <el-tree :data="config.configDefaultColumn"
                   style="max-height: 200px;overflow-y: auto;"
                   default-expand-all
                   show-checkbox
                   draggable
                   node-key="prop"
                   ref="configTableListTree"
                   @check-change="handleCheckChange"
                   @node-drop="handleDrop"
                   :allow-drag="allowDrag"
                   :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
          </el-tree>
          <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
        </el-popover>
        <br/>
        <br/>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-switch
                  v-model="config.configModeForm.defaultOrNot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'">
              </el-switch>
            </div>
          </el-col>
        </el-row>
      </el-row>


      <el-table :data="dataList"
                ref="tableRef"
                @row-click="rowClick"
                :row-style="selectedHighlight"
                height="72vh"
                size="small"
                v-loading="dataListLoading"
                border
                style="width: 100%;"
                :cell-class-name="getCellClassName">
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 模型标识 -->
            <template v-if="item.prop == 'key'">
              <el-button type="text" size="mini" @click="operation('VIEW',scope.row)">
                <span>{{ scope.row.key }}</span>
              </el-button>
            </template>
            <!-- 模型版本 -->
            <template v-else-if="item.prop == 'version'">
              <el-tag size="medium" >v{{ scope.row.version }}</el-tag>
            </template>
            <!-- 描述 -->
            <template v-else-if="item.prop == 'remarks'">
              <span>{{ scope.row.metaInfo ? JSON.parse(scope.row.metaInfo).description : '' }}</span>
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>
        <af-table-column fixed="right" header-align="left" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="operation('UPDATE',scope.row)" icon="el-icon-brush">设计</el-button>
            <el-button type="text" size="small" @click="operation('DEPLOYMENT',scope.row)" icon="el-icon-video-play">部署</el-button>
            <el-dropdown size="mini">
              <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-view" @click.native="operation('VIEW',scope.row)">流程图</el-dropdown-item>
                <el-dropdown-item icon="el-icon-price-tag" @click.native="handleHistory(scope.row)">历史</el-dropdown-item>
                <el-dropdown-item icon="el-icon-delete" @click.native="deleteHandle(scope.row)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </af-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="dataForm.page"
                     :page-sizes="[20, 50, 100]" :page-size="dataForm.size" :total="dataForm.total"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />

    <!-- 流程图-查看 -->
    <el-dialog :title="processView.title" :visible.sync="processView.open" width="70%" append-to-body>
      <process-viewer :key="`designer-${processView.index}`" :xml="processView.xmlData" :style="{height: '700px'}" />
    </el-dialog>

    <!-- 流程图-设计 -->
    <el-dialog :title="designerData.title" :visible.sync="designerOpen" append-to-body fullscreen>
      <process-designer
          :key="designerOpen"
          style="border:1px solid rgba(0, 0, 0, 0.1);"
          ref="modelDesigner"
          v-loading="designerData.loading"
          :bpmnXml="designerData.bpmnXml"
          :designerForm="designerData.form"
          @save="onSaveDesigner"
      />
    </el-dialog>

    <!-- 模型历史 -->
    <el-dialog title="模型历史" :visible.sync="history.open" width="70%" >
      <el-table :data="dataListV2"
                ref="tableRefV2"
                height="60vh"
                size="small"
                v-loading="dataListLoadingV2"
                border
                style="width: 100%;"
                :cell-class-name="getCellClassName">
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 模型标识 -->
            <template v-if="item.prop == 'key'">
              <el-button type="text" size="mini" @click="operation('VIEW',scope.row)">
                <span>{{ scope.row.key }}</span>
              </el-button>
            </template>
            <!-- 模型版本 -->
            <template v-else-if="item.prop == 'version'">
              <el-tag size="medium" >v{{ scope.row.version }}</el-tag>
            </template>
            <!-- 描述 -->
            <template v-else-if="item.prop == 'remarks'">
              <span>{{ scope.row.metaInfo ? JSON.parse(scope.row.metaInfo).description : '' }}</span>
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>
        <af-table-column fixed="right" header-align="left" width="300" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="operation('DEPLOYMENT',scope.row)" icon="el-icon-video-play">部署</el-button>
            <el-button type="text" size="small" @click="deleteHandle(scope.row)" icon="el-icon-delete">删除</el-button>
            <el-button type="text" size="small" @click="handleLatest(scope.row)" icon="el-icon-star-off">设置为最新版</el-button>
          </template>
        </af-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandleV2" @current-change="currentChangeHandleV2" :current-page="dataFormV2.page"
                     :page-sizes="[20, 50, 100]" :page-size="dataFormV2.size" :total="dataFormV2.total"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import configTable from '@/components/table'
import * as myJsonClon from "@/utils/myJsonClone"
import { formattedDateTimeHHmm } from "@/utils/common"
import ProcessViewer from '@/components/flowable/ProcessViewer'
import ProcessDesigner from '@/components/flowable/ProcessDesigner'
export default {
  data() {
    return {
      // -----------------动态表格模式start-----------------
      config: {
        configId: null,
        configTableId: 56,
        configDefaultColumn: [
          {label: '模型标识',prop: 'key',check: true,fixed: undefined},
          {label: '模型名称',prop: 'name',check: true,fixed: undefined},
          {label: '模型类型',prop: 'category',check: true,fixed: undefined},
          {label: '模型版本',prop: 'version',check: true,fixed: undefined},
          {label: '描述',prop: 'remarks',check: true,fixed: undefined},
          {label: '创建时间',prop: 'createTime',check: true,fixed: undefined},
        ],
        configDefaultPropColumn: [],
        isConfigMode: false,
        configModeForm: {
          name: '',
          remark: '',
          defaultOrNot: '0'
        },
        configDefaultPropColumnMap: new Map(),
      },
      // -----------------动态表格模式end-----------------


      // 搜索信息
      dataForm: {
        page: 1,
        size: 20,
        total: 0,
        paramMap: {}
      },
      dataFormV2: {
        page: 1,
        size: 20,
        total: 0,
        paramMap: {}
      },

      // 表格
      dataList: [],
      dataListV2: [],
      getIndex: -1,
      dataListLoading: false,
      dataListLoadingV2: false,

      // 流程图-查看/设计/历史
      processView: {
        title: '流程设计',
        open: false,
        index: undefined,
        xmlData:"",
      },
      designerOpen: false,
      designerData: {
        loading: false,
        bpmnXml: '',
        modelId: null,
        form: {
          appType: [],
          processAppType: '',
          processName: null,
          processKey: null
        }
      },
      history: {
        open: false,
        loading: false
      },
    }
  },
  components: {configTable,ProcessDesigner,ProcessViewer},
  activated() {
    this.initConfigTable();
    this.getDataList()
  },
  computed: {
    dictTypeMap: {
      get() {
        return this.$store.state.common.dictTypeMap
      }
    }
  },
  methods: {
    formattedDateTimeHHmm,
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })

        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    // -----------------动态表格模式end-----------------

    /**
     * 点击表格变色
     * @param row 当前行数据
     * @param rowIndex 当前行号
     * @returns {{"background-color": string}}
     */
    selectedHighlight({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    rowClick(row) {
      this.getIndex = row.index
    },

    /**
     * 每页大小
     * @param val 当前选中页大小
     */
    sizeChangeHandle(val) {
      this.dataForm.size = val
      this.dataForm.page = 1
      this.getDataList()
    },

    /**
     * 当前页
     * @param val 当前选中的页数
     */
    currentChangeHandle(val) {
      this.dataForm.page = val
      this.getDataList()
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true

      // 执行
      this.$http({
        url: this.$http.adornUrl('/flowable/model/page'),
        method: 'post',
        data: this.dataForm
      }).then(({ data }) => {
        this.dataList = data.records
        this.dataForm.total = data.total
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 删除
    deleteHandle(row) {
      this.$confirm('是否确认删除模型标识为"' + row.key + '"的数据项？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/flowable/model'),
          method: 'delete',
          data: {ids: [row.id]}
        }).then(({ data }) => {
          this.getDataList()
        }).finally(() => {})
      }).catch(() => { })
    },

    // 添加/修改/查看流程设计
    operation(type,row) {
      // 重置
      let THIS = this
      THIS.designerData = this.$options.data().designerData
      THIS.processView = this.$options.data().processView
      THIS.designerOpen = false


      let time = new Date().getTime();
      // 新增
      if (type == 'ADD') {
        THIS.designerData.loading = true
        THIS.designerData.title = "流程设计-" + `业务流程_${time}`
        THIS.designerData.modelId = null
        THIS.designerData.form = {
          appType: [],
          processKey: `TMS_${time}`,
          processName: `业务流程_${time}`,
        }
        THIS.designerData.bpmnXml = ''
        THIS.designerData.loading = false
        THIS.designerOpen = true
      }
      // 查看
      else if (type == 'VIEW') {
        let modelId = row.id;
        THIS.processView.title = row.key + '-' + row.name;
        THIS.processView.index = modelId;
        this.$http({
          url: this.$http.adornUrl('/flowable/model/bpmnXml/' + row.id),
          method: 'get',
        }).then(({ data }) => {
          THIS.processView.xmlData = data
          THIS.processView.open = true
        }).finally(() => {})
      }
      // 修改
      else if (type == 'UPDATE') {
        THIS.designerData.title = "流程设计 - " + row.name
        THIS.designerData.modelId = row.id
        THIS.designerData.form = {
          appType: [],
          processAppType: row.category,
          processName: row.name,
          processKey: row.key
        }
        if (row.id) {
          THIS.designerData.loading = true;
          this.$http({
            url: this.$http.adornUrl('/flowable/model/bpmnXml/' + row.id),
            method: 'get',
          }).then(({ data }) => {
            THIS.designerData.bpmnXml = data
            THIS.designerData.loading = false
            THIS.designerOpen = true
          }).finally(() => {})
        }
      }
      // 部署
      else if (type == 'DEPLOYMENT') {
        this.$http({
          url: this.$http.adornUrl('/flowable/model/deploy'),
          method: 'get',
          params: this.$http.adornParams({
            'id': row.id,
          })
        }).then(({ data }) => {
          this.$message.success('部署成功')
        }).finally(() => {})
      }
    },
    onSaveDesigner(bpmnXml) {
      this.bpmnXml = bpmnXml;
      let dataBody = {
        id: this.designerData.modelId,
        xml: this.bpmnXml
      }

      // 执行
      this.designerData.loading = true
      this.$http({
        url: this.$http.adornUrl('/flowable/model'),
        method: dataBody.id ? 'put' : 'post',
        data: dataBody
      }).then(({ data }) => {
        this.$message.success('处理成功')
        this.designerOpen = false
        this.getDataList()
      }).finally(() => {
        this.designerData.loading = false
      })
    },

    // 历史
    handleHistory(row) {
      // 重置
      this.dataFormV2 = this.$options.data().dataFormV2
      this.dataListV2 = []
      this.history = this.$options.data().history

      // 执行
      this.dataFormV2.paramMap.key = row.key
      this.history.open = true
      this.getHistoryList()
    },
    getHistoryList() {
      this.dataListLoadingV2 = true

      // 执行
      this.$http({
        url: this.$http.adornUrl('/flowable/model/historyList'),
        method: 'post',
        data: this.dataFormV2
      }).then(({ data }) => {
        this.dataListV2 = data.records
        this.dataFormV2.total = data.total
      }).finally(() => {
        this.dataListLoadingV2 = false
      })
    },
    sizeChangeHandleV2(val) {
      this.dataFormV2.size = val
      this.dataFormV2.page = 1
      this.getHistoryList()
    },
    currentChangeHandleV2(val) {
      this.dataFormV2.page = val
      this.getHistoryList()
    },

    /** 设为最新版 */
    handleLatest(row) {
      this.$confirm('是否确认将此版本设为最新？').then(() => {
        this.history.loading = true

        this.$http({
          url: this.$http.adornUrl('/flowable/model/latest'),
          method: 'post',
          params: this.$http.adornParams({modelId: row.id})
        }).then(({ data }) => {
          this.history.open = false
          this.getDataList()
          this.$message.success('设置成功')
        }).finally(() => {
          this.history.loading = false;
        })
      })
    },
  }
}
</script>
